export const SCENE_DURATION = 10.0;
export const TOTAL_SCENES = 11.0;
export const BLACK_HOLE_SCENE_INDEX = 10.0;
